module.exports = __webpack_public_path__ + "static/button-91ff15a82ead0ad3239094b277238bdd.png";